import _ from "lodash";

import AppConstants from "../constants";
import { TipDataResponse, TipInterface } from "./DriverHelperTipInterface";
import { getUniqueValues } from "../utils/helpers.utils";
import moment from "moment";
import {
  PayloadFilters,
  ExtendedPayloadFilters,
} from "./DriverHelperTipInterface";

const getFilterAttributeValue = (
  attrValue: Array<{ value: string }> | string[],
  noKey?: boolean
) => {
  let currentValue = noKey
    ? attrValue
    : attrValue.map((item: any) => item.value);
  const selectAllIdx = currentValue.indexOf(AppConstants.SELECT_ALL.value);
  const selectNoneIdx = currentValue.indexOf(AppConstants.SELECT_NONE.value);
  if (selectAllIdx > -1) {
    currentValue = [];
  }
  if (selectNoneIdx > -1) {
    currentValue = [];
  }
  return currentValue;
};

export const createFetchTipRecordsPayload = (
  payload: PayloadFilters,
  data?: { pageNumber: number; totalPages: number },
  isLoadMore?: boolean,
  countryCode?: string,
  selectedChip?: string
): ExtendedPayloadFilters => {
  const extendedPayload: ExtendedPayloadFilters = {
    countryISOCode:
      sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode,
    countryCode:
      sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode,
    attributes: [],
    pageSize: payload.pageSize,
    pageNumber: 0,
    searchAttribute: payload.searchAttribute,
  };

  if (payload.dateRange) {
    if (
      payload.dateRange &&
      payload.dateRange.value &&
      typeof payload.dateRange.value === "object" &&
      "startDate" in payload.dateRange.value &&
      "endDate" in payload.dateRange.value
    ) {
      extendedPayload.isDateRange = true;
      extendedPayload.dateRange = {
        startTime: moment(
          payload.dateRange.value.startDate,
          AppConstants.DATE_FORMAT
        ).format(AppConstants.DATE_FORMAT_API),
        endTime: moment(
          payload.dateRange.value.endDate,
          AppConstants.DATE_FORMAT
        ).format(AppConstants.DATE_FORMAT_API),
      };
    }
  }
  if (
    Array.isArray(payload.consignmentStatus.value) &&
    payload.consignmentStatus.value.length > 0
  ) {
    let attrValue: ReturnType<typeof getFilterAttributeValue> = [];
    if (payload.consignmentStatus.value) {
      attrValue = getFilterAttributeValue(payload.consignmentStatus.value);
      extendedPayload.attributes.push({
        key: payload.consignmentStatus.key,
        value: attrValue,
      });
    }
  }
  if (
    Array.isArray(payload.assigneeVendor.value) &&
    payload.assigneeVendor.value.length > 0
  ) {
    let attrValue: ReturnType<typeof getFilterAttributeValue> = [];
    if (payload.assigneeVendor.value) {
      attrValue = getFilterAttributeValue(payload.assigneeVendor.value);
      extendedPayload.attributes.push({
        key: payload.assigneeVendor.key,
        value: attrValue,
      });
    }
  }
  if (payload.assigneeType.value) {
    let attrValue: string[] = [];
    const currentValue = payload.assigneeType.value;
    if (currentValue === AppConstants.SELECT_ALL.value) {
      attrValue = [];
    } else {
      attrValue = [String(currentValue)];
    }
    extendedPayload.attributes.push({
      key: payload.assigneeType.key,
      value: attrValue,
    });
  }
  if (
    Array.isArray(payload.hubCode.value) &&
    payload.hubCode.value.length > 0
  ) {
    let hubCodeValue = payload.hubCode.value.map(
      (item: { value: string }) => item.value
    );
    const selectAllIdx = hubCodeValue.indexOf(AppConstants.SELECT_ALL.value);
    const selectNoneIdx = hubCodeValue.indexOf(AppConstants.SELECT_NONE.value);
    if (selectAllIdx > -1) {
      hubCodeValue = [];
    }
    if (selectNoneIdx > -1) {
      hubCodeValue = [];
    }
    if (hubCodeValue.length) {
      extendedPayload.attributes.push({
        key: payload.hubCode.key,
        value: getUniqueValues(hubCodeValue),
      });
    }
  }
  if (selectedChip) {
    if (selectedChip === "ALL") {
      const obj = {
        key: "deliveryType",
        value: [],
      };
      extendedPayload.attributes.push(obj);
    } else {
      const obj = {
        key: "deliveryType",
        value: [selectedChip],
      };
      extendedPayload.attributes.push(obj);
    }
  } else {
    const obj = {
      key: "deliveryType",
      value: [],
    };
    extendedPayload.attributes.push(obj);
  }

  if (isLoadMore && data) {
    extendedPayload.pageNumber =
      data.pageNumber + 1 < data.totalPages
        ? data.pageNumber + 1
        : extendedPayload.pageNumber;
  }

  return extendedPayload;
};

export const transformDataList = (
  response: TipDataResponse
): TipInterface[] => {
  const transformedArray: TipInterface[] = [];
  response.elements.forEach((tipObject: TipInterface) => {
    transformedArray.push({
      ...tipObject,
    });
  });
  return [...transformedArray];
};
